export default {
    title: `How to improve your score?`,
    text1: `Your credibility score is based on the quality of your audience and the ratio of followers qualified as “fake”.`,
    text1b: `The more you have, the lower your score is. Followers considered as “fake” can be spotted based on the following criteria:`,
    point1: `If the account has way more following than followers,`,
    point2: `If the account does not have a profile picture,`,
    point3: `If the account is inactive or without any posts.`,
    text2: `You can always block those accounts. This will improve at the same time and in the long run your engagement rate :)`,
};
